<template>
  <b-card
    title="مدیریت تیکت ها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <b-row
          align-h="end"
          align-v="end"
        >
          <b-col
              md="auto"
              class="mr-auto"
          >
            <b-button
                class="mb-1"
                variant="primary"
                @click="showModal = true"
            >
              جدید
            </b-button>
          </b-col>
          <b-col
            md="auto"
            style="width: 150px"
          >
            <b-form-group
              label="متن"
              label-for="Title"
            >
              <b-form-input
                v-model="filterOptions.Title"
                @keyup.enter="update(1)"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="auto"
            style="width: 150px"
          >
            <b-form-group
              label="شماره تیکت"
              label-for="ID"
            >
              <b-form-input
                v-model="filterOptions.ID"
                type="number"
                @keyup.enter="update(1)"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="auto"
            style="width: 150px"
          >
            <b-form-group
              label="شناسه کاربر"
              label-for="UserId"
            >
              <b-form-input
                v-model="filterOptions.UserId"
                type="number"
                @keyup.enter="update(1)"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="auto"
            style="width: 150px"
          >
            <b-form-group
              label="دپارتمان"
              label-for="Title"
            >
              <departmentList
                v-model="filterOptions.TicketDepartmentId"
                :multiple="false"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="auto"
            style="width: 150px"
          >
            <b-form-group
              label="وضعیت"
              label-for="TicketStatus"
            >
              <v-select
                v-model="filterOptions.Status"
                :options="enums('TicketStatus')"
                dir="rtl"
                label="text"
                :reduce="x => x.value"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="auto"
            style="width: 150px"
          >
            <b-form-group
              label="از تاریخ"
              label-for="ID"
            >
              <date-picker
                v-model="filterOptions.FromDate"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col
            md="auto"
            style="width: 150px"
          >
            <b-form-group
              label="تا تاریخ"
              label-for="ID"
            >
              <date-picker
                v-model="filterOptions.ToDate"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="auto">
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              class="mb-1"
              variant="warning"
              @click="update(1)"
            >فیلتر
            </b-button>
          </b-col>
        </b-row>
        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'ticketReply', params: { id: data.item.Id }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>
          <template #cell(User)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.value.Id }}">
              <b-media
                vertical-align="center"
                style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                    :src="data.value.Image"
                  />
                </template>
                <span
                  class="font-weight-bold d-block text-nowrap"
                  style="color: #6e6b7b;"
                >
                  <template v-if="data.value.Name || data.value.Family">{{ data.value.Name }} {{ data.value.Family }}</template>
                  <template v-else>کاربر زیره</template>
                </span>
                <small class="text-muted">{{ data.value.Id }}</small>
              </b-media>
            </b-link>
          </template>
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="enums('TicketStatus', 'value', data.value, 'badge')"
            >
              {{ enums('TicketStatus', 'value', data.value, 'text') }}
            </b-badge>
          </template>
          <template #cell(TicketDepartment)="data">
            <span>
              {{ data.value.Title }}
            </span>
          </template>
          <template #cell(CreatedAt)="data">
            <span>{{ data.value | date }}</span>
          </template>
          <template #cell(actions)="data">
            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'ticketReply', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EyeIcon"
                  size="16"
                />
              </b-link>
            </div>
          </template>
          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>
    </b-row>
    <b-modal
        v-model="showModal"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="ایجاد تیکت"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
        @cancel="closeMakeTicket()"
        @hide="closeMakeTicket()"
    >
<!--      <b-overlay :show="ticket.openTicketLoading"> </b-overlay>-->
      <b-row>
        <b-col md="12">
          <b-form-group
              label="شناسه کاربر"
              label-for="UserId"
          >
            <b-form-input
                v-model="ticket.UserId"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
              label="عنوان"
              label-for="Title"
          >
            <b-form-input
                id="Title"
                v-model="ticket.Title"
                name="Title"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
              label="دپارتمان"
              label-for="department"
          >
            <departmentList
                v-model="ticket.TicketDepartmentId"
                :multiple="false"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
import departmentList from '@/tools/departmentList'
import {BInputGroupAppend} from 'bootstrap-vue'

export default {
  name: 'TicketList',
  components: {
    departmentList,
    BInputGroupAppend
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      showModal: false,
      filterOptions: {
        Title: null,
        Page: 1,
        TicketDepartmentId: null,
        PerPage: 10,
        Status: null,
        UserId: null,
        ToDate: null,
        FromDate: null,
        SortBy: 'Id',
        IsDesc: true,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'User',
          label: 'نام و نام خانوادگی',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'TicketDepartment',
          label: 'دپارتمان',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      date: null,
      ticket: {
        TicketDepartmentId: null,
        Title: null,
        Mobile: null,
        UserId: null,
        disablePhoneNumber: false,
        openTicketLoading: false
      }
    }
  },

  created() {
    console.log(this.$route.query)
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    } else if (this.$route.query.userid > 0){
      this.filterOptions.UserId = this.$route.query.userid
    }

    this.update()
  },
  methods: {
    closeMakeTicket(){
      this.ticket= {
        TicketDepartmentId: null,
        Title: null,
        Mobile: null,
        UserId: null,
        disablePhoneNumber: false,
        openTicketLoading: false
      }
    },
    searchUserByPhone(){
      this.ticket.openTicketLoading = true
      this.$http.post(
          this.$api.user.getlist, {
            Mobile:this.ticket.Mobile,
            page:1
          },
      )
          .then(res => {
            if(res.data.length > 0 ){
              this.ticket.UserId = res.data[0].Id
              this.ticket.disablePhoneNumber=true
              this.ticket.openTicketLoading = false
            }
          })
          .finally(() => {
            this.loading = false
          })
    },
    save() {
      this.ticket.openTicketLoading = true
      this.$http.post(this.$api.ticket.openTicket, this.ticket).then((res) => {
        this.ticket.openTicketLoading = false
        this.$router.push({ name: 'ticketReply', params: { id: res.data.Id } })
      })
    },
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      // keep state for set info in table when user is back from next component
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.ticket.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.removeRow(this.$api.food.remove, 'Id', id)
    },
  },
}
</script>
